






































import Vue from 'vue'
import moment from 'moment/moment'
import config from '@/utils/config'
import request from '@/utils/request'
import conditionList from './json/conditionList.json'
import preColors from './json/pre_colors.json'
import temColors from './json/tem_colors.json'
import windElement from '@/utils/windElement'
import staIdsData from '@/utils/staIdsData.json'
import CimissDataService from '@/service/CimissDataService'
import barListDataJson from './json/barListData.json'
import { redefineStationInfo } from '@/utils/stations_utils'
export default Vue.extend({
  props: ['barId'],
  watch: {
    barId(val) {
      const data = conditionList as any
      this.dataList = data[this.barId].data
      this.unit = data[this.barId].unit
      this.check = false
      const params = { check: this.check, data: {} }
      this.onChangeBar()
      this.$emit('checkCondition', params)
    },
  },
  data() {
    return {
      dataList: [] as any,
      barListData: barListDataJson,
      check: false,
      checkText: '',
      unit: '',
      subListData: [] as any,
      subId: '',
      startTime: '',
      endTime: '',
      timeTag: 0,
      timeShow: false,
      minDate: new Date(2019, 0, 1, 0),
      maxDate: new Date(),
      currentDate: new Date(),
      initData: [],
      timeRange: '',
      timeStr: '',
      hourNum: 0,
    }
  },
  created() {
    const data = conditionList as any
    this.dataList = data[this.barId].data
    this.unit = data[this.barId].unit

    this.onChangeBar()

  },
  methods: {
    onChangeBar() {
      if (this.barId !== 'radar' && this.barId !== 'satellite') {
        this.barListData.filter((e) => {
          if (e.id === this.barId) {
            if (e.children) {
              this.subListData = e.children
            } else {
              this.subListData = []
            }
          }
        })

      }
      if (this.subListData.length > 0) {
        this.subId = this.subListData[0].id
      } else {
        this.subId = this.barId
      }
      console.log(this.subId)
      this.changeSub(this.subId)
    },
    checked() {
      this.check = false
      this.checkText = ''
      const params = { check: this.check, data: {} }
      this.$emit('checkCondition', params)
    },
    checkCondtion(item: any) {
      // 取消选择
      if (item.text === this.checkText) {
        this.check = false
        this.checkText = ''
      } else {
        this.check = true
        this.checkText = item.text
      }

      const params = { check: this.check, data: item }
      this.$emit('checkCondition', params)

    },

    changeSub(id: any) {
    
      this.subId = id
      if (id === 'pre_any') {
        this.startTime = moment(this.currentDate).add(-1, 'hours').format('YYYY-MM-DD HH:00')
        this.endTime = moment(this.currentDate).format('YYYY-MM-DD HH:00')
        this.timeStr = moment(new Date()).format('YYYY年MM月DD日HH时')
      }
      if (this.barId === 'pre') {
        this.hourNum = 0
        const num = this.subId.split('_')[1].split('h')[0]
        const start = moment(new Date()).add(- (Number(num) - 1), 'hours').subtract(8,'hours').format('YYYYMMDDHH0000')
        const end = moment(new Date()).subtract(8,'hours').format('YYYYMMDDHH0000')
        this.timeRange = `${start},${end}`
        if (num === '1') {
          this.timeStr = moment(new Date()).format('YYYY年MM月DD日HH时')
        } else {
          this.timeStr = `${moment(new Date()).add(- (Number(num)), 'hours').format('YYYY年MM月DD日HH时')}-${moment(new Date()).format('MM月DD日HH时')}`
        }
        this.getStatData()
      } else if (this.barId === 'tem' && this.subId !== 'tem') {
        const start = moment(new Date()).add(-24, 'hours').subtract(8,'hours').format('YYYYMMDDHH0000')
        const end = moment(new Date()).subtract(8,'hours').format('YYYYMMDDHH0000')
        this.timeRange = `${start},${end}`
        this.timeStr = `${moment(new Date()).add(-24, 'hours').format('YYYY年MM月DD日HH时')}-${moment(new Date()).format('MM月DD日HH时')}`
        this.getStatData()
      } else if (this.barId === 'tem' && this.subId === 'tem') {
        this.hourNum = 0
        this.timeStr = moment(new Date()).format('YYYY年MM月DD日HH时')
        this.getliveData()
      } else {
        this.getTableData()
      }
    },
    // 任意时间查询
    changeTime(value: any) {
      this.timeTag = value
      this.timeShow = true
      if (this.timeTag === 1) {
        const arr = this.startTime.split(':')[0].split(' ')[0].split('-')
        arr.push(this.startTime.split(':')[0].split(' ')[1])
        this.currentDate = new Date(Number(arr[0]), Number(arr[1]) - 1, Number(arr[2]), Number(arr[3]))
      } else {
        const arr = this.endTime.split(':')[0].split(' ')[0].split('-')
        arr.push(this.endTime.split(':')[0].split(' ')[1])
        this.currentDate = new Date(Number(arr[0]), Number(arr[1]) - 1, Number(arr[2]), Number(arr[3]))
      }
    },
    confirm() {
      this.timeShow = false
      if (this.timeTag === 1) {
        this.startTime = moment(this.currentDate).format('YYYY-MM-DD HH:00')
      } else {
        this.endTime = moment(this.currentDate).format('YYYY-MM-DD HH:00')
      }
    },
    cancel() {
      this.timeShow = false
    },
    query() {
      const arrStart = this.startTime.split(' ')
      const arrEnd = this.endTime.split(' ')
      const start = arrStart[0].replace(/-/g, '') + arrStart[1].split(':')[0] + '0000'
      const utfStart = moment(start, 'YYYYMMDDHHmmss').format('YYYYMMDDHHmmss')
      const end = arrEnd[0].replace(/-/g, '') + arrEnd[1].split(':')[0] + '0000'
      const utfEnd = moment(end, 'YYYYMMDDHHmmss').format('YYYYMMDDHHmmss')
      this.timeRange = `${utfStart},${utfEnd}`
      this.timeStr = `${moment(start, 'YYYYMMDDHHmmss').format('YYYY年MM月DD日HH时')}-${moment(end, 'YYYYMMDDHHmmss').format('YYYY年MM月DD日HH时')}`
      this.getStatData()
    },
    getliveData() {
      const elements = 'station_name,station_id_c,tem,tem_min,tem_max,win_s_avg_2mi,win_d_avg_2mi,win_s_inst_max,win_d_inst_max,rhu,lat,lon,datetime,prs'
      CimissDataService.stationData('',config.defaultStationObj.adminCode,'', '', elements).then((data: any) => {
        // console.log(data)
        const redefinedData = redefineStationInfo(data)
        this.initData = redefinedData
        this.getTableData()
      })
    },
    getStatData() {
      // console.log(this.timeRange)
      // const url = '/dmz/surface_stat/list/surf_hour_data'
      // const params = {
      //   // adminCodes: config.defaultStationObj.adminCode,
      //   staIds: config.staIds,
      //   elements: 'station_name,station_id_c,pre_1h,tem_min,tem_max,lat,lon',
      //   timeRange: this.timeRange,
      // }
      const elements = 'station_name,station_id_c,pre_1h,tem_min,tem_max,lat,lon'
      CimissDataService.stationStatData('',config.defaultStationObj.adminCode, this.timeRange, '', elements).then((data: any) => {
        // request.get(url, params).then((data) => {
        const redefinedData = redefineStationInfo(data)
        this.initData = redefinedData
        this.getTableData()
      })
    },
    changeHour(value: any) {
      // console.log(value)
      let num = this.hourNum
      if (value === 'back' && this.hourNum > -12) {
        if (this.hourNum <= 0 && this.hourNum > -12) {
          num--
        }
        this.hourNum = num
      } else if (value === 'next' && this.hourNum < 0) {
        if (this.hourNum < 0 && this.hourNum >= -12) {
          num++
        }
        this.hourNum = num
      }
      this.timeStr = moment().add(this.hourNum, 'hour').format('YYYY年MM月DD日HH时')
      this.gethistData()
    },
    gethistData() {
      const times = `${moment().add(this.hourNum, 'hours').format('YYYYMMDDHH0000')}`
      const url = '/cw/surface_data/list/surf_hour_data'
      const params = {
        // adminCodes: config.defaultStationObj.adminCode,
        staIds: config.staIds,
        elements: 'station_name,station_id_c,pre_1h,tem,win_s_avg_2mi,win_d_avg_2mi,win_s_inst_max,win_d_inst_max,rhu,lat,lon,datetime,prs',
        times,
      }
      request.get(url, params).then((data) => {
        const redefinedData = redefineStationInfo(data)
        this.initData = redefinedData
        this.getTableData()
      })
    },
    getTableData() {
      // @ts-ignore
      const detailStatJson = statisticsList[type].data
      console.log(detailStatJson)


      const data = JSON.parse(JSON.stringify(this.initData))
      data.map((e: any) => {

        let key = this.subId
        if (this.barId === 'pre') {
          key = 'pre_1h'
        }

        e.value = e[key]
        let arrBgColor = [] as any
        if (this.barId === 'wind') {
          e.bgColor = ''
          e.level = windElement.windLevel(e[this.subId])
          e.windImg = windElement.windVane(e.value)
          if (this.subId === 'win_s_avg_2mi') {
            e.rotate = e.win_d_avg_2mi
          } else if (this.subId === 'win_d_inst_max') {
            e.rotate = e.win_d_inst_max
          }
        } else if (this.barId === 'rhu') {
          e.bgColor = '#00BFFF'
        } else if (this.barId === 'pre') {
          arrBgColor = preColors
        } else if (this.barId === 'tem') {
          arrBgColor = temColors
        } else if (this.barId === 'prs') {
          e.bgColor = '#00BFFF'
        }
        arrBgColor.map((k: any) => {
          if (e.value >= k[0] && e.value < k[1]) {
            e.bgColor = `rgba(${k[2]}, ${k[3]}, ${k[4]}, 1.0)`
            if (e.value < 0.09) {
              e.bgColor = 'rgba(0, 0, 0, 0.20)'
            }
          }
        })
      })

      const arr = data.filter((e: any) => {
        return e.value >= 0
      })
      const params = {
        // data,
        data: arr,
        timeStr: this.timeStr,
      }
      this.$emit('getData', params)
    },


  },
})
